import { render } from "./WidgetTotalScore.vue?vue&type=template&id=848242fc"
import script from "./WidgetTotalScore.vue?vue&type=script&lang=js"
export * from "./WidgetTotalScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__